module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei6.svg";